<div class="ts-discover">
  <div class="ts-discover__shell">

    <header class="ts-section-head">
      <div class="ts-section-head__lead">
        <div class="t-meta ts-eyebrow">Community</div>
        <h1 class="t-h1 ts-section-head__title">Discover books</h1>
        <p class="t-lede ts-section-head__lede">
          Books finished by fellow Talespinners, written with a little help from AI.
          Find your next read, or the push to finish your own.
        </p>
      </div>
    </header>

    <hr class="ts-hr-thin">

    <section class="ts-discover__grid" aria-label="Featured books">
      <div class="ts-book-grid">
        @for (book of publicBooks; track book.id) {
          <a class="ts-book" [routerLink]="['/book-project', book.id]" target="_blank">
            <div class="ts-book__cover">
              @if (!coverLoading[book.id]) {
                <img [src]="bookCovers[book.id]" [alt]="book.title">
              } @else {
                <div class="ts-book__cover-loading">Loading…</div>
              }
            </div>

            <div class="ts-book__body">
              <h3 class="ts-book__title">{{ book.title }}</h3>
              <p class="ts-book__author">by {{ book.author }}</p>

              @if (book.genre) {
                <div class="ts-book__genre-row">
                  <span class="ts-book__genre">{{ book.genre }}</span>
                </div>
              }

              <div class="ts-book__metrics">
                <span class="ts-book__metric">
                  <svg class="ts-book__metric-icon" viewBox="0 0 24 24" aria-label="Views" role="img"><path d="M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 8a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-12.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z"/></svg>
                  {{ book.metrics.uniqueViews }}
                </span>
                <span class="ts-book__metric">
                  <svg class="ts-book__metric-icon" viewBox="0 0 24 24" aria-label="Likes" role="img"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5 2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
                  {{ book.metrics.totalLikes }}
                </span>
              </div>
            </div>

            <div class="ts-book__overlay">
              <div class="ts-book__overlay-content">
                <h4 class="ts-book__overlay-title">{{ book.title }}</h4>
                <p class="ts-book__overlay-desc">{{ book.description }}</p>
              </div>
            </div>
          </a>
        }
      </div>
    </section>

    @if (totalItems > pageSize) {
      <nav class="ts-pagination" aria-label="Page navigation">
        <ul class="ts-pagination__list">
          <li class="ts-pagination__item" [class.ts-pagination__item--disabled]="currentPage === 1">
            <a class="ts-pagination__link"
               href="javascript:void(0)"
               (click)="onPageChange(currentPage - 1)"
               aria-label="Previous">‹</a>
          </li>
          @for (page of pages; track page) {
            <li class="ts-pagination__item" [class.ts-pagination__item--active]="currentPage === page">
              <a class="ts-pagination__link"
                 href="javascript:void(0)"
                 (click)="onPageChange(page)">{{ page }}</a>
            </li>
          }
          <li class="ts-pagination__item" [class.ts-pagination__item--disabled]="currentPage === totalPages">
            <a class="ts-pagination__link"
               href="javascript:void(0)"
               (click)="onPageChange(currentPage + 1)"
               aria-label="Next">›</a>
          </li>
        </ul>
      </nav>
    }
  </div>
</div>
